import React, { PropsWithChildren, useState } from 'react';
import { motion, useAnimation, Variants } from 'framer-motion';

import IconChevron from '@/assets/icons/heroIcons/Chevron-down.svg';
import { mergeClasses } from '@/utils/style';

interface OldDocumentsToggleProps {
	openedTitle: string;
	closedTitle: string;
	className?: string;
	initialOpen?: boolean;
}

export const OldDocumentsToggle = (props: PropsWithChildren<OldDocumentsToggleProps>) => {
	const { openedTitle, closedTitle, className, children, initialOpen = false } = props;

	const [isOpen, setIsOpen] = useState(initialOpen);
	const controls = useAnimation();

	const toggleDropdown = () => {
		setIsOpen((prev) => {
			controls.start(!prev ? 'open' : 'closed');
			return !prev;
		});
	};

	const variants: Variants = {
		open: { height: 'auto', opacity: 1 },
		closed: { height: 0, opacity: 0 },
	};

	return (
		<>
			<button
				type="button"
				onClick={toggleDropdown}
				aria-expanded={isOpen}
				className={mergeClasses(
					'mx-auto flex items-center justify-center gap-1 text-blue-500 lg:justify-start',
					className
				)}
			>
				<span className="shrink-0 font-semibold">{isOpen ? openedTitle : closedTitle}</span>
				<div
					className={mergeClasses(
						'shrink-0 transform transition-transform duration-300',
						isOpen ? 'rotate-180' : 'rotate-0'
					)}
				>
					<IconChevron className="h-6 w-6" aria-hidden="true" />
				</div>
			</button>
			<motion.div
				className="overflow-hidden"
				animate={controls}
				initial={initialOpen ? 'open' : 'closed'}
				variants={variants}
			>
				<div className="inline-block pt-4">{children}</div>
			</motion.div>
		</>
	);
};
